<template>
  <div>
    <div class="content">
      <div class="title-box">
        <h3 class="pull-left">{{detailLan.datailText}}&nbsp;&nbsp;({{queryObj.REPORT_ID}})</h3>
        <div class="pull-right" style="margin-top:12px;">
          <el-button
            @click="$router.go(-1)"
            class="preview-btn"
            round
            type="warning"
          >{{detailLan.goback}}</el-button>
        </div>
        <div class="clear"></div>
      </div>
      <div class="panel" element-loading-spinner="el-icon-loading" v-loading="loading">
        <mtable
          :downLoadTran="downLoadTran"
          :jsonExcelAjax="jsonExcelAjax"
          :multiLanguage="detailLan"
          :name="name"
          :thData="thData"
          :trData="trData"
          v-if="trData"
        >
          <div class="monthly-detail" slot="handle">
            <div class="monthly-detail">
              <span>{{detailLan.proxyAccount}}&nbsp;{{queryObj.IB_ID}}</span>
            </div>
            <div class="monthly-detail">
              <span>{{detailLan.commissionType}}&nbsp;{{queryObj.type}}</span>
            </div>
            <div class="monthly-detail" v-if="isLower">
              <el-switch
                :active-text="detailLan.spread"
                :inactive-text="detailLan.fold"
                @change="actionChange"
                active-color="#3F51B5"
                v-model="action"
              ></el-switch>
            </div>
          </div>
        </mtable>
      </div>
    </div>
  </div>
</template>
<script>
import mtable from '../../comm/mytable'
import { URL_IBMONTHLYDETAIL } from 'api/commissionApi'
import { Api } from 'api/commissionEnv'
let api = new Api()

export default {
  name: 'monthCommDetailResult',
  mixins: [require('common/mixin/base.js').base({ detailLan: 'monthlyIBResult' }), require('common/mixin/base.js').base({ publicLan: 'publicLan' })],
  props: ['curArea'],
  data() {
    return {
      trData: [],
      queryObj: {},
      url: '',
      action: false,
      isLower: false,
      loading: true,
      product: {},
      thKeys: []
    }
  },
  mounted() {
    this.queryObj = this.$route.query
    this.tableAjax()
  },
  methods: {
    actionChange(value) {
      this.action = value
      this.tableAjax()
    },
    tableAjax() {
      this.loading = true
      let tableObj = {
        params: {
          report_id: this.queryObj.REPORT_ID,
          type: this.queryObj.TYPE,
          id: this.queryObj.IB_ID
        }
      }
      this.url = api.getUrl20(this.curArea, URL_IBMONTHLYDETAIL)
      this.$http.get(this.url, tableObj).then(res => {
        this.trData = res.data.data.data
        this.group = res.data.data.group
        if (this.trData.length == 0) {
          this.thKeys.push('CLIENT_ID')
          this.thKeys.push('PLATFORM')
          this.thKeys.push('TRADING_ACCOUNT_ID')

          let arr = Object.keys(this.group).filter(v => v != 'ALL')
          for (let v of arr) {
            this.thKeys.push(v + '_LOT')
            this.thKeys.push(v + '_REBATE_DIFF')
            this.thKeys.push(v + '_COMMISSION_DIFF')
          }
        } else {
          this.thKeys = Object.keys(this.trData[0])
        }
        this.setOfficeState()
        this.loading = false
      })
    },
    setOfficeState() {
      let total = this.detailLan.detailTotal
      let internal = this.detailLan.internal
      let afterrule = this.detailLan.afterrule
      if (Object.prototype.toString.call(this.trData) == '[object Array]') {
        this.trData.forEach((item, index) => {
          let temp = this.trData[index]
          if (this.queryObj.TYPE == 1) {
            let group = temp.PRODUCT_GROUP
            let rule = temp.RULE_ID
            temp.rule_id = temp.RULE_ID ? this.publicLan.rule[temp.RULE_ID] : ''
            temp.product_group = temp.PRODUCT_GROUP ? this.publicLan.products[temp.PRODUCT_GROUP] : ''
            if (index !== this.trData.length - 1) {
              temp.ib_id = temp.IB_ID
              return true
            }
            temp.ib_id = this.detailLan.total[temp.IB_ID]
            return true
          }
          if (index > this.trData.length - 3) {
            temp.trading_account_id = temp.TRADING_ACCOUNT_ID ? total[temp.TRADING_ACCOUNT_ID] : ''
            temp[this.thKeys[4].toLowerCase()] = internal[temp[this.thKeys[4]]]
            temp[this.thKeys[6].toLowerCase()] = temp[this.thKeys[6]] ? (afterrule[temp[this.thKeys[6]]] ? afterrule[temp[this.thKeys[6]]] : temp[this.thKeys[6]]) : ''
            return true
          }

          temp.client_id = temp.CLIENT_ID
          temp[this.thKeys[2].toLowerCase()] = temp[this.thKeys[2]]
          temp[this.thKeys[4].toLowerCase()] = temp[this.thKeys[4]]
          temp[this.thKeys[6].toLowerCase()] = temp[this.thKeys[6]]
        })
      }
    }
  },
  computed: {
    thData() {
      if (this.queryObj.TYPE == 0) {
        //if(this.thKeys.length == 0) return this.detailLan.extraDetail
        let arr = []
        for (let v of this.thKeys) {
          let obj = {}
          obj.key = v
          obj.name = this.publicLan.detailTh[v]
          arr.push(obj)
        }
        if (arr.length != 0) {
          arr[2].key = arr[2].key.toLowerCase()
          arr[4].key = arr[4].key.toLowerCase()
          arr[6].key = arr[6].key.toLowerCase()
        }
        return arr
      }
      return this.detailLan.lowerTh
    },
    name() {
      return this.detailLan.datailText
    },
    downLoadTran() {
      if (this.queryObj.TYPE == 1) {
        return {
          IB_ID: this.detailLan.total,
          RULE_ID: this.publicLan.rule,
          PRODUCT_GROUP: this.publicLan.products
        }
      }
      let dlObj = { TRADING_ACCOUNT_ID: this.detailLan.detailTotal }
      dlObj[this.thKeys[4]] = this.detailLan.internal
      dlObj[this.thKeys[6]] = this.detailLan.afterrule
      return dlObj
    },
    jsonExcelAjax() {
      return {
        url: this.url,
        ajaxType: 'get',
        getKey: ['data', 'data', 'data'],
        rID: this.queryObj.REPORT_ID,
        cID: this.queryObj.IB_ID,
        type: this.detailLan.typeList[this.queryObj.TYPE],
        ajaxPar: {
          report_id: this.queryObj.REPORT_ID,
          type: this.queryObj.TYPE,
          id: this.queryObj.IB_ID
        }
      }
    }
  },
  watch: {
    detailLan() {
      this.queryObj.type = this.detailLan.typeList[this.queryObj.TYPE]
      this.setOfficeState()
    },
    curArea() {
      this.$router.push('monthlyIBResult')
    }
  },
  components: {
    mtable
  }
}
</script>
<style lang="scss" type="text/scss" scoped>
.title-box {
  border: 1px solid #3f51b5;
  background: #3f51b5;
  padding: 0 20px;
  color: #fff;
  border-radius: 5px 5px 0 0;
  .preview-btn {
    border: 1px solid #f08712;
    background-color: #f08712;
    border-radius: 5px;
  }
}
.monthly-detail {
  float: left;
  margin-right: 50px;
}
</style>



// WEBPACK FOOTER //
// monthCommDetailResult.vue?45b9a600